// import { Injectable } from "@nestjs/common";

// Injectable()
// export class ExpensesService {
//     constructor(
//     ){ }
// }
import { Injectable } from '@nestjs/common';
import * as fs from 'fs';
import * as xlsx from 'xlsx'; // npm install xlsx
import { Repository } from 'typeorm';
import { InjectRepository } from '@nestjs/typeorm';
import { ExpensesEntity } from './expenses.entity';
import {
  ExpensesColumns,
  ExpensesModelDto,
  ExpensesResponseModel,
} from '@gtpl/shared-models/finance';
import { CommonResponse } from '@gtpl/shared-models/masters';
import { ExpensesDTO } from './expenses.dto';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import { ExpensesLogEntity } from './expensesLog.entity';

@Injectable()
export class ExpensesService {
  constructor(
    @InjectRepository(ExpensesEntity)
    private expensesRepository: Repository<ExpensesEntity>
  ) {}

  async ExpensesuploadExcel(formData: any): Promise<ExpensesResponseModel> {
    console.log(formData, 'oooooooser');
    const transactionManager = new GenericTransactionManager();
    try {
      await transactionManager.startTransaction();
      const flag = new Set<boolean>();
      const columnArray = [];
      const updatedArray = formData.map((obj) => {
        const updatedObj = {};
        for (const key in obj) {
          const newKey = key
            .replace(/\s/g, '')
            .replace(/[\(\)\.]/g, '')
            .replace(/-/g, '');
          if (newKey != '') {
            columnArray.push(newKey);
            updatedObj[newKey] = obj[key];
          }
        }
        return updatedObj;
      });
      const difference = columnArray.filter(
        (element) => !ExpensesColumns.includes(element)
      );
      console.log(difference, '----');
      if (difference.length > 0) {
        await transactionManager.releaseTransaction();
        return new ExpensesResponseModel(
          false,
          1110,
          "Excel columns doesn't match. Please attach the correct file."
        );
      }
      const convertedData = updatedArray.map((obj) => {
        const updatedObj = {};
        for (const key in obj) {
          const value = obj[key];
          if (value === '') {
            updatedObj[key] = null;
          } else {
            updatedObj[key] = value;
          }
        }
        return updatedObj;
      });
      // const deleteData = await transactionManager.getRepository(ExpensesEntity).delete({})
      // if (deleteData) {
      //     flag.add(true)
      // } else {
      //     flag.add(false)
      //     return new ExpensesResponseModel(false, 0, 'Something wwent wrong in data deletion')
      // }
      for (const data of convertedData) {
        // let dtoData
        if (data.Amount != null && data.Month <= 12) {
          const existedData = await this.expensesRepository.findOne({
            where: {
              head: data.Head,
              category: data.Category,
              month: data.Month,
            },
          });
          if (existedData) {
            const update = await transactionManager
              .getRepository(ExpensesEntity)
              .update({ id: existedData.id }, { amount: data.Amount });
            if (!update.affected) {
              flag.add(false);
              await transactionManager.releaseTransaction();
              return new CommonResponse(
                false,
                0,
                'Something went wrong in updating existing record'
              );
            } else {
              const logs = new ExpensesLogEntity();
              logs.amount = existedData.amount;
              logs.category = existedData.category;
              logs.head = existedData.head;
              logs.month = existedData.month;
              logs.expenseId = existedData.id;
              const addupdatedData = await transactionManager
                .getRepository(ExpensesLogEntity)
                .save(logs);
              if (addupdatedData) {
                flag.add(true);
              } else {
                flag.add(false);
                await transactionManager.releaseTransaction();
                break;
              }
            }
          } else {
            const addObj = new ExpensesEntity();
            addObj.amount = data.Amount;
            addObj.category = data.Category;
            addObj.head = data.Head;
            addObj.month = data.Month;
            const addSave = await transactionManager
              .getRepository(ExpensesEntity)
              .save(addObj);
            if (addSave) {
              flag.add(true);
            } else {
              flag.add(false);
              await transactionManager.releaseTransaction();
              return new ExpensesResponseModel(false, 0, 'Somthing went wrong in saving the data');
            }
          }
        }else{
          flag.add(false)
          await transactionManager.releaseTransaction()
          return new ExpensesResponseModel(false,0,'Please check Month or Amount')
        }
      }
      if (!flag.has(false)) {
        await transactionManager.completeTransaction();
        return new ExpensesResponseModel(true, 1, 'Data saved successfully');
      } else {
        await transactionManager.releaseTransaction();
        return new ExpensesResponseModel(false, 0, 'Something went wrong');
      }
    } catch (err) {
      await transactionManager.releaseTransaction();
      return new ExpensesResponseModel(false, 0, 'Something went wrong');
    }
  }

  async getExpenses(): Promise<ExpensesResponseModel> {
    try {
        let res = []
      const info = await this.expensesRepository.find();
      if (info.length>0) {
        for (const data of info){
            res.push(new ExpensesModelDto(data.id,data.category, data.head, data.month, data.amount ))
        }
        return new ExpensesResponseModel(true, 1, 'Data retrieved', info);
      } else {
        return new ExpensesResponseModel(false, 0, 'No data found');
      }
    } catch (err) {
      return new ExpensesResponseModel(false, 0, 'Something went wrong', err);
    }
  }
}
